<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <page-header v-if="props.promotionId" class="mb-6 lg:mb-12">
            <template v-slot:subtitle>
                <a href="/settings/integrations/promotions" class="no-underline! text-sky-600! text-base font-normal">
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Promotions
                </a>
            </template>

            <slot name="header">{{ promotion.name }}</slot>
        </page-header>

        <div
            :class="{
                'grid grid-cols-12 items-start': props.promotionId,
            }"
        >
            <page-sidebar
                v-if="props.promotionId"
                :links="[
                    {
                        href: `/settings/integrations/promotions/${props.promotionId}`,
                        label: 'Details',
                    },
                    {
                        href: `/settings/integrations/promotions/${props.promotionId}/coupons`,
                        label: 'Coupon Codes',
                    },
                    {
                        href: `/settings/integrations/promotions/${props.promotionId}/coupons/imports`,
                        label: 'Imports',
                    },
                ]"
            ></page-sidebar>
            <slot></slot>
        </div>
    </form-container>
</template>

<script setup>
import PageLoading from '~/components/general/PageLoading.vue';
import FormContainer from '~/components/general/FormContainer.vue';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import PageHeader from '~/components/general/PageHeader.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { usePromotionDetails } from '~/components/promotions/usePromotionDetails';
import { onMounted } from 'vue';

const props = defineProps({
    promotionId: {
        type: Number,
        required: false,
    },
});

const { promotion, loading, mount } = usePromotionDetails();

onMounted(() => {
    mount(props.promotionId);
});
</script>
